import React from 'react';
import { Modal } from 'react-bootstrap';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import styled from 'styled-components';
import Button from '../../../components/Button/Button';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { isNotStandaloneMobilePWA } from '../../../utils/mobileSupported';

const PiggyBankInfo = ({
  openModal,
  closeInfoScreen,
  tutorialScreen,
  findIndexScreen,
  handleBackScreen,
  handleFowardScreen,
  piggyBankAssets,
}) => {
  return (
    <Modal backdrop={false} show={openModal} dialogClassName="gtp-modal-piggy-bank modal-dialog-centered">
      <Modal.Body>
        <ModalContainer>
          <ImageBackground src={tutorialScreen} />
          <CloseButton onClick={closeInfoScreen} src={piggyBankAssets.PIGGY_BANK_CLOSE_BUTTON} />
          <BackButton
            onClick={handleBackScreen}
            imageSource={assetSource(ASSET_KEY.BACK_ARROW)}
            display={findIndexScreen() === 0 ? 'none' : 'flex'}
          />
          <ForwardButton
            onClick={handleFowardScreen}
            imageSource={assetSource(ASSET_KEY.RIGHT_ARROW)}
            display={findIndexScreen() === 1 ? 'none' : 'flex'}
          />
          <GoButton
            onClick={closeInfoScreen}
            label={getText(TEXT_KEY.PIGGY_BANK_INFO_BUTTON)}
            textStroke={BUTTON_STROKES.PRIMARY}
            display={findIndexScreen() === 0 ? 'none' : 'flex'}
          />
        </ModalContainer>
      </Modal.Body>
    </Modal>
  );
};

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const CloseButton = styled.img`
  width: 3dvw;
  height: 3dvw;
  object-fit: contain;
  position: absolute;
  top: 8.5dvw;
  right: 23dvw;
  cursor: pointer;
  ${({ theme }) =>
    theme.screens.device('mobile-browser') &&
    `
    top: 7.5dvw;
    right: 27dvw;
    `}
`;

const arrowStyle = {
  position: 'absolute',
  width: '3dvw',
  cursor: 'pointer',
  zIndex: 1,
};

const BackButton = styled(Button).attrs({
  containerStyle: { ...arrowStyle, left: isNotStandaloneMobilePWA ? '27dvw' : '23dvw' },
  imageStyle: { width: '100%', objectFit: 'contain' },
})``;

const ForwardButton = styled(Button).attrs({
  containerStyle: { ...arrowStyle, right: isNotStandaloneMobilePWA ? '27dvw' : '23dvw' },
  imageStyle: { width: '100%', objectFit: 'contain' },
})``;

const GoButton = styled(Button).attrs({
  containerStyle: `
  position: absolute;
  bottom: 4.5dvw;
  width: 22dvw;
  cursor: pointer;
  z-index: 1;
   ${
     isNotStandaloneMobilePWA &&
     `
      bottom: 3.5dvw;
    `
   }
`,
  textStyle: { textTransform: 'uppercase', fontSize: '2dvw' },
  imageStyle: { width: '100%', objectFit: 'contain' },
  imageSource: assetSource(ASSET_KEY.ROUNDEDRECT_PRIMARY_WIDE),
})``;

export default PiggyBankInfo;

